export const stylesToDefaultMarkValues = (
  defaults: Record<string, any>,
  styles: Record<string, any>
) => {
  const allStyles = { ...defaults, ...styles };
  const markValues = {};

  const keyMap = {
    color: 'color',
    face: 'font-family',
    'font-family': 'font-family',
    lineHeight: 'line-height',
    'line-height': 'line-height',
    size: 'font-size',
    'font-size': 'font-size',
    style: 'font-style',
    'font-style': 'font-style',
    weight: 'font-weight',
    'font-weight': 'font-weight'
  };

  const validKeyNames = Object.keys(keyMap);

  for (let key in allStyles) {
    if (validKeyNames.some((name) => name === key)) {
      markValues[keyMap[key]] = allStyles[key];
    }
  }

  return markValues;
};
